import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TransferComponent } from '../transfer/transfer.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-transfer-list',
  templateUrl: './transfer-list.component.html',
  styleUrls: ['./transfer-list.component.css']
})
export class TransferListComponent implements OnInit {

  public menu_item_id = '60';
  public add_auth;
  public edit_auth;
  public del_auth;
  // user_info = this.applicationConstants.user_info;
  user = [];

  private dp = [];
  displayedColumns = ['trans_no', 'from_acct_name', 'to_acct_name', 'trans_amount', 'trans_date', 'edit', 'del'];
  displayedColumns2 = ['trans_no', 'from_acct_name', 'to_acct_name', 'trans_amount', 'trans_date'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<TransferComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'transfer', 'transfer_type': 'all', 'trans_no': '',
    'from_date': new Date(), 'to_date': new Date(), 'branch_id': '0', 'title': 'التحويلات'
  };

  branchList = [];

  Success_Msg; Error_Msg; Del_Msg; Trnans_List; From_Date; To_Date;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Trnans_List').subscribe((res: string) => {
      this.Trnans_List = res;
    });
    this.model['title'] = this.Trnans_List;

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT `user`.*, `employee`.`name` FROM `user`, `employee` WHERE `acct_number` = '" + this.applicationConstants.user_info.casher_acct_number
      + "' AND `user`.`employee_no` = `employee`.`employee_no`";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.user = data.data['list'];
      });

    query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    // this.model['from_date'] = undefined;
  }

  search() {
    let condition = "";

    if (this.model['from_date'] != undefined && this.model['to_date'] != undefined) {

      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + " 00:00:00";
      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate() + " 23:59:59";

      if (this.model['from_date'] == this.model['to_date'])
        condition += " AND `transfer`.`trans_date` = '" + from_date + "'";

      else
        condition += " AND `transfer`.`trans_date` BETWEEN '" + from_date + "' AND '" + to_date + "'";
    }

    else if (this.model['from_date'] != undefined && this.model['to_date'] == undefined) {
      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + " 00:00:00";
      condition += " AND `transfer`.`trans_date` >= '" + from_date + "'";
    }
    else if (this.model['from_date'] == undefined && this.model['to_date'] != undefined) {
      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate() + " 23:59:59";
      condition += " AND `transfer`.`trans_date` <= '" + to_date + "'";
    }

    if (this.model['trans_no'] != '')
      condition = " AND `transfer`.`trans_no` LIKE '%" + this.model['trans_no'] + "%'";

    if (this.model['branch_id'] != '0')
      condition += " AND `transfer`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '0') {
      let index = 1;
      let list_length = this.branchList.length;

      condition += " AND `transfer`.`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '0') {
          if (index < list_length)
            condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      condition += ")";
    }

    let query;

    if (this.model['transfer_type'] != 'all') {

      if (this.model['transfer_type'] == 'sent')
        condition += " AND `transfer`.`from_acct` = '" + this.applicationConstants.user_info.casher_acct_number + "' AND `transfer`.`to_acct` = `user`.`acct_number`";

      else if (this.model['transfer_type'] == 'received')
        condition += " AND `transfer`.`to_acct` = '" + this.applicationConstants.user_info.casher_acct_number + "' AND `transfer`.`from_acct` = `user`.`acct_number`";


      query = "SELECT `transfer`.*, `user`.`user_id`, `user`.`acct_number`, `employee`.`name` FROM `transfer`, `user`, `employee`" +
        " WHERE `transfer`.`status` <> '0' AND `user`.`employee_no` = `employee`.`employee_no` " + condition +
        "  ORDER BY `transfer`.`trans_no`";
    }

    else {
      query = "(SELECT `transfer`.*, `user`.`user_id`, `employee`.`name` FROM `transfer`, `user`, `employee`" +
        " WHERE `transfer`.`status` <> '0' AND `transfer`.`from_acct` = '" + this.applicationConstants.user_info.casher_acct_number +
        "' AND `transfer`.`to_acct` = `user`.`acct_number` AND `user`.`employee_no` = `employee`.`employee_no`" +
        condition + ")" +
        " UNION (SELECT `transfer`.*, `user`.`user_id`, `employee`.`name`  FROM `transfer`, `user`, `employee` " +
        " WHERE `transfer`.`status` <> '0' AND `transfer`.`to_acct` = '" + this.applicationConstants.user_info.casher_acct_number +
        "' AND `transfer`.`from_acct` = `user`.`acct_number` AND `user`.`employee_no` = `employee`.`employee_no` " +
        condition + ")";
    }
    // console.log(query);
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        data.data['list'].forEach(element => {
          if (element.from_acct == this.applicationConstants.user_info.casher_acct_number) {
            element.from_acct_name = this.user['0']['name'];
            element.to_acct_name = element.name;
          }
          else {
            element.to_acct_name = this.user['0']['name'];
            element.from_acct_name = element.name;
          }
          element.date = element.trans_date;
          element.trans_date = (element.trans_date).substring(0, 10);
          // if (element.status == '1')
          //   element.status = "بانتظار التأكيد";
          // else if (element.status == '2')
          //   element.status = "مؤكد";
          // else if (element.status == '3')
          //   element.status = "مرفوض";
          // else if (element.status == '4')
          //   element.status = "ملغي";

        });
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  accept(row) {
    let where = [{ 'trans_id': row['trans_id'] }];
    let value = [{ 'table_name': this.model['table_name'], 'status': '2' }];
    let obj = { cmd: 'update', values: value, where: where };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        alert(this.Success_Msg);
        this.search();
      });
  }

  reject(row) {
    let where = [{ 'trans_id': row['trans_id'] }];
    let value = [{ 'table_name': this.model['table_name'], 'status': '3' }];
    let obj = { cmd: 'update', values: value, where: where };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        alert(this.Success_Msg);
        this.search();
      });
  }

  newTransfer() {
    this.addDialogRef = this.dialog.open(TransferComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  editTransfer(row) {
    let dialog_data = {
      'table_name': 'transfer', 'trans_id': row.trans_id,
      'trans_no': row.trans_no,
      'from_acct': row.from_acct,
      'to_acct': row.to_acct,
      'flag': 'update',
      'key': 'trans_id',
      'trans_amount': row.trans_amount,
      'trans_date': row.date,
      'status': row.status,
      'comment': row.comment,
      'branch_id': row.branch_id
    };
    this.addDialogRef = this.dialog.open(TransferComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delTrans(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'trans_no': row.trans_no }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="50%"> ' + this.From_Date + ': ' + this.model['from_date'].getFullYear() + "-" +
      (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + '</td>';
    html_data += '<td width="50%"> ' + this.To_Date + ': ' + this.model['to_date'].getFullYear() + "-" +
      (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate() + ' </td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('transfer_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
